// libraries
import { useState, useContext } from "react";
import { useHistory, Redirect } from "react-router-dom";
import { useToasts } from "react-toast-notifications";

// styles
import "../../styles/AdminLogin.css";

// context
import AdminContext from "../../context/admin";

// icons
import { FaUser, FaLock } from "react-icons/fa";
import UserLoading from "../../components/Loading";

const AdminLogin = () => {
  // use context
  const { loading, admin, adminStatus, setAdminStatus } = useContext(
    AdminContext,
  );

  // use state
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // use history
  const history = useHistory();

  // use toast
  const { addToast } = useToasts();

  const submitForm = () => {
    if (!email || !password) {
      addToast("Please fill all the fields", {
        appearance: "error",
      });
    } else {
      if (email === admin.email && password === admin.password) {
        history.push("/admin");
        localStorage.setItem("admin", email);
        setAdminStatus(email);
      } else {
        addToast("Admin credentials do not match", {
          appearance: "error",
        });
      }
    }
  };

  if (adminStatus !== null) {
    <Redirect to='/admin' />;
  }

  return (
    <div className='admin-container'>
      {loading && <UserLoading fixed={true} />}
      <div className='admin-form-box'>
        <div className='admin-header-form'>
          <h4>Login To Delighyte Admin</h4>
        </div>
        <div className='admin-body-form'>
          <form>
            <div className='input-group mb-3'>
              <div className='input-group-prepend'>
                <span className='input-group-text'>
                  <i className='fa fa-user'>
                    <FaUser />
                  </i>
                </span>
              </div>
              <input
                type='email'
                className='form-control'
                placeholder='Email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className='input-group mb-3'>
              <div className='input-group-prepend'>
                <span className='input-group-text'>
                  <i className='fa fa-lock'>
                    <FaLock />
                  </i>
                </span>
              </div>
              <input
                type='password'
                className='form-control'
                placeholder='Password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            {/* <div className='admin-message'>
              <div>
                <input
                  type='checkbox'
                  value={remember}
                  onChange={(e) => setRemember(e.target.checked)}
                />
                Remember Me
              </div>
            </div> */}
            <button
              type='button'
              className='btn btn-secondary btn-block admin-button'
              onClick={submitForm}
            >
              LOGIN
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
export default AdminLogin;
